import { render, staticRenderFns } from "./ModalApprove.vue?vue&type=template&id=3d6ea3fa&scoped=true&"
import script from "./ModalApprove.vue?vue&type=script&lang=ts&"
export * from "./ModalApprove.vue?vue&type=script&lang=ts&"
import style0 from "./ModalApprove.vue?vue&type=style&index=0&id=3d6ea3fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6ea3fa",
  null
  
)

export default component.exports